interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  /** Looks and behaves as off-limits (aria-disabled), but stays focusable so its reason can be explained. */
  disabled?: boolean;
  busy?: boolean;
  /** Id of the element that describes the switch (for assistive technology). */
  describedBy?: string;
}

export const Switch = ({ checked, onChange, label, disabled = false, busy = false, describedBy }: SwitchProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-disabled={disabled || busy}
    aria-label={label}
    aria-describedby={describedBy}
    onClick={() => {
      if (!busy) onChange();
    }}
    className={`flex h-7 w-11 flex-none items-center rounded-full border-0 p-0.5 transition-colors ${
      checked ? 'justify-end bg-primary' : 'justify-start bg-stone-300'
    } ${disabled ? 'cursor-not-allowed opacity-50' : busy ? 'cursor-wait opacity-70' : 'cursor-pointer'}`}
  >
    <span className="block h-6 w-6 rounded-full bg-white" />
  </button>
);
